import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { LeagueProviderMappingDto } from "@/types/ApiResponses/League";

export interface GetLeagueMappingsParams {
  providerId?: number;
}

export const getLeagueMappings = async (
  leagueId: number,
  props: QueryProps<GetLeagueMappingsParams>
): Promise<LeagueProviderMappingDto[]> => {
  const res = await api.client.get(`/leagues-new/${leagueId}/mappings`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
